// Small trust row shown under a CTA button — "Card required · £0 today · cancel anytime".
const CardInform = ({
    cardText = 'Card required',
    priceText = '£0 today',
    cancelText = 'cancel anytime',
}) => (
    <div className="d-flex align-items-center gap-2 extra-small fw-medium mt-1" style={{ color: 'var(--sk-text-light)' }}>
        <span>{cardText}</span>
        <span>&middot;</span>
        <span className="text-sk-green fw-semi-bold">{priceText}</span>
        <span>&middot;</span>
        <span>{cancelText}</span>
    </div>
);

export default CardInform;
